import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';

import './i18n/config';

import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { applyDirection } from './utils/rtl';

// Apply saved language direction on load (safely)
try {
  const savedLanguage = localStorage.getItem('language') || 'en';
  applyDirection(savedLanguage);
} catch (error) {
  console.warn('Could not access localStorage:', error);
  applyDirection('en');
}

// Register PWA service worker with auto-update
try {
  registerSW({
    onNeedRefresh() {
      if (confirm('New version available. Reload now?')) {
        window.location.reload();
      }
    },
    onOfflineReady() {
      console.log('VireoHR is ready to work offline.');
    }
  });
} catch (error) {
  console.warn('Service Worker registration failed:', error);
}

// Render app
const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>,
  );
} else {
  console.error('Root element not found');
}
